module.exports = "<div> <p v-el:numone>0</p> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/demos/CountUp.vue
 ** module id = 181
 ** module chunks = 0
 **/